// import React from 'react';

import './styles/style.scss';

export { default } from './Table';



// WEBPACK FOOTER //
// ./src/components/Table/index.js